export { default } from './carousel';
export { default as carouselConfig } from './carousel.config';
